/**
 * TanStack Query 키 네임스페이스
 * - 튜플 배열 형태로 통일
 * - 캐시 무효화 시 `queryClient.invalidateQueries({ queryKey: queryKeys.posts.all })`
 */
export const queryKeys = {
  auth: {
    me: ['auth', 'me'] as const,
  },
  users: {
    detail: (userId: string) => ['users', 'detail', userId] as const,
    stats: (userId: string) => ['users', 'stats', userId] as const,
  },
  posts: {
    all: ['posts'] as const,
    list: (boardId: number | 'all', sort?: string) => ['posts', 'list', boardId, sort] as const,
    detail: (postId: number) => ['posts', 'detail', postId] as const,
    hot: ['posts', 'hot'] as const,
  },
  comments: {
    byPost: (postId: number) => ['comments', 'post', postId] as const,
  },
  market: {
    prices: ['market', 'prices'] as const,
    price: (ticker: string) => ['market', 'price', ticker] as const,
    kimchi: ['market', 'kimchi'] as const,
    upbitMarkets: ['market', 'markets', 'upbit'] as const,
    tickerBar: ['market', 'ticker-bar'] as const,
    sidebar: ['market', 'sidebar'] as const,
  },
  tickers: {
    detail: (code: string) => ['tickers', 'detail', code] as const,
    guidance: (code: string) => ['tickers', 'guidance', code] as const,
  },
  point: {
    me: ['point', 'me'] as const,
    history: (type?: string) => ['point', 'history', type] as const,
    checkinStatus: ['point', 'checkin', 'status'] as const,
  },
  exchange: {
    items: ['exchange', 'items'] as const,
    history: ['exchange', 'history'] as const,
  },
  notifications: {
    list: ['notifications'] as const,
    unread: ['notifications', 'unread'] as const,
  },
  diaries: {
    mine: ['diaries', 'mine'] as const,
    stats: ['diaries', 'stats'] as const,
  },
  virtual: {
    portfolio: ['virtual', 'portfolio'] as const,
    history: ['virtual', 'history'] as const,
  },
  premium: {
    me: ['premium', 'me'] as const,
  },
  search: {
    results: (q: string, type?: string) => ['search', q, type] as const,
    autocomplete: (q: string) => ['search', 'autocomplete', q] as const,
    popular: ['search', 'popular'] as const,
  },
} as const;
